import { Stack, Title } from '@mantine/core'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import OrderForm from 'components/orders/OrderForm'
import { getOrderQueryOptions } from 'hooks/orders'

export const Route = createFileRoute('/_auth/orders/edit/$orderNumber')({
  loader: async ({ params, context: { queryClient } }) => {
    return await queryClient.ensureQueryData(getOrderQueryOptions(parseInt(params.orderNumber)))
  },
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  const order = useSuspenseQuery(getOrderQueryOptions(parseInt(params.orderNumber))).data

  return (
    <Stack gap="xl">
      <Title order={1}>Edytuj zamówienie Z-{order.id}</Title>
      <OrderForm order={order} />
    </Stack>
  )
}
